import { fetchSampleRequestBarcodesData } from '../../Service/ApiService';
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';

const BarcodeDesignController = () => {
  const navigate = useNavigate();
  const location = useLocation();
const [isDataLoading, setIsDataLoading] = useState(false);
  // Get designNumber from route state
  const designNumber = location.state?.designNumber || '';
  console.log('Design Number in Controller--->>', designNumber);

  const user = JSON.parse(localStorage.getItem('user'));
  const [barcodeData, setBarcodeData] = React.useState([]);

  // ✅ Fetch initial design data on mount
  useEffect(() => {
    if (designNumber) {
      getData(designNumber);
    }
  }, []);

  // ✅ Base fetch function for design number
  const getData = async (designNo) => {
    try {
      setIsDataLoading(true);
      const res = await fetchSampleRequestBarcodesData(
        user.userId,
        '',
        user.userCode,
        user.userVerticalId,
        '',
        designNo
      );

      if (res && res.success === 'true') {
        // Replace full data (initial load)
        setBarcodeData(res.materialList || []);
        setIsDataLoading(false);
      } else {
        setBarcodeData([]);
        setIsDataLoading(false);
      }
    } catch (err) {
      setIsDataLoading(false);
      console.error('Error fetching barcode data:', err);
    }
  };

  // ✅ Append new design data to existing barcode list
  const addMoreBarcode = async (designNo) => {
      console.log('addMoreBarcode api Design Number in Controller-----', designNo);
    try {
      const res = await fetchSampleRequestBarcodesData(
        user.userId,
        '',
        user.userCode,
        user.userVerticalId,
        '',
        designNo
      );

      if (res && res.success === 'true') {
        const newItems = res.materialList || [];
        if (newItems.length > 0) {
          // Merge with existing, prevent duplicates by barcode
          setBarcodeData((prev) => {
            const existingBarcodes = new Set(prev.map((item) => item.barcode));
            const uniqueNew = newItems.filter(
              (item) => !existingBarcodes.has(item.barcode)
            );
            return [...prev, ...uniqueNew];
          });
        }
      } else {
        console.warn('No data found for this Design Number:', designNo);
      }
    } catch (err) {
      console.error('Error adding more barcode data:', err);
    }
  };

  const handleRemoveBarcode = (barcode) => {
    const updatedData = barcodeData.filter((item) => item.barcode !== barcode);
    setBarcodeData(updatedData);
  };

  const handleProceed = () => {
    if (barcodeData.length === 0) {
      alert('Please add at least one barcode before proceeding.');
      return;
    }
    navigate('/sample-request-selection', { state: { barcodeData } });
  };

  const handleClearButtonClick = () => {
    setBarcodeData([]);
  };

  return {
    barcodeData,
    handleClearButtonClick,
    handleRemoveBarcode,
    handleProceed,
    addMoreBarcode, 
    isDataLoading,
    setIsDataLoading
  };
};

export default BarcodeDesignController;
